// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f8698279","453":"61b53916"}[chunkId] + ".chunk.js";
};